module.exports = __webpack_public_path__ + "media/home/Home-Mosaics-79eadfd1.jpg";